<template>
  <CookieModal />
  <TermsModal />
  <PrivacyModal />
  <router-view/>
</template>

<script>
import TermsModal from '@/components/modals/TermsModal.vue';
import PrivacyModal from '@/components/modals/PrivacyModal.vue';
import CookieModal from '@/components/modals/CookieModal';

export default {
  name: 'App',
  components: {
    CookieModal
  }
}
</script>
